import axios from "axios"

export const getGraficoReembolso = async () => {
    return axios.get(`api/Home/GetGraficoReembolso`)
}

export const getKpis2 = async () => {
    return axios.get('api/Home/GetKpis')
}

